import { useSelector } from "react-redux";

/**
 * USE this selector instead of the react useSelector if you get stability warnings for the 
 * selectors related to the form
 * @param {*} state 
 * @param {*} stabilityCheck 
 * @returns 
 */
export function useAmsSelector(state) {
  var stabilityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "never";
  var useStabilizedSelector = useSelector(state, {
    devModeChecks: {
      stabilityCheck: stabilityCheck
    }
  });
  return useStabilizedSelector;
}